import { useCallback } from 'react';

/**
 * Assigning a ref to a ref-function or ref-object (current)
 * @param {function || object} ref
 * @param {object} node
 */
export const safelyAssignRef = (ref, node) => {
  if (!ref) {
    return;
  }

  if (typeof ref === 'function') {
    ref(node);
  }
  if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
    ref.current = node;
  }
};

export const useMultipleRefsSetter = (...refs) => {
  const singleRefCallback = useCallback(
    node => {
      refs.forEach(ref => safelyAssignRef(ref, node));
    },
    [refs]
  );

  return singleRefCallback;
};
